import { render } from "./SimpleConfirmationModal.vue?vue&type=template&id=49bbc18e"
import script from "./SimpleConfirmationModal.vue?vue&type=script&lang=js"
export * from "./SimpleConfirmationModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__